import LazyLoad from '@/utils/AsyncRouteHelper'
import ApplicationRoutes from './routes/applications'
import VuseRoutes from './routes/vuse'
import VuetifyRoutes from './routes/vuetify'

import PingTest from '@/views/Pages/Authentication/Signup/PingTest.vue'
import Test from '@/components/test.vue' // test.vue를 import

const AppSidebar = () =>
  import(
    /* webpackChunkName: "Vusenavs", webpackPreload: true */ '@/layouts/App/Sidebar'
  )
const AppToolbar = () =>
  import(
    /* webpackChunkName: "Vusenavs", webpackPreload: true */ '@/layouts/App/Toolbar'
  )
const AppFooter = () =>
  import(
    /* webpackChunkName: "Vusenavs",  webpackPreload: true */ '@/layouts/App/Footer'
  )

const AllRoutes = [...ApplicationRoutes, ...VuetifyRoutes, ...VuseRoutes]
const routes = AllRoutes.map((route) => {
  const { params, defaultComponentPath, navs } = route
  const componentObj = navs
    ? {
        components: {
          default: LazyLoad(defaultComponentPath),
          sidebar: AppSidebar,
          header: AppToolbar,
          footer: AppFooter,
        },
      }
    : {
        component: LazyLoad(defaultComponentPath),
      }
  return {
    ...params,
    ...componentObj,
  }
})

export default [
  {
    path: '/',
    redirect: '/dashboard/operational',
  },
  {
    path: '/ping-test', // PingTest 라우트 정의
    name: 'PingTest',
    component: PingTest,
  },
  {
    path: '/test', // /test 경로 추가
    name: 'Test',
    component: Test, // test.vue와 연결
  },
  ...routes, // 기존 라우트 추가
]
